export default function detectBrowserSpeed() {
  const _speedconstant = 1.15600e-8; //if speed=(c*a)/t, then constant=(s*t)/a and time=(a*c)/s
  const d = new Date();
  const amount = 150000000;
  // console.log("JSBenchmark by Aaron Becker, running loop " + amount + " times.     Estimated time (for " + estprocessor + "ghz processor) is " + (Math.round(((_speedconstant * amount) / estprocessor) * 100) / 100) + "s");
  for (let i = amount; i > 0; i--) {}
  const newd = new Date();
  const accnewd = Number(`${String(newd.getSeconds())}.${ String(newd.getMilliseconds())}`);
  const accd = Number(`${String(d.getSeconds())}.${ String(d.getMilliseconds())}`);
  let di = accnewd - accd;
  //console.log(accnewd,accd,di);
  if (d.getMinutes() != newd.getMinutes()) {
    di = (60 * (newd.getMinutes() - d.getMinutes())) + di;
  }
  const spd = ((_speedconstant * amount) / di);
  return Math.round(spd * 1000) / 1000;
}